import hres96uLabels from 'assets/labels/hres96u'
import faker from 'faker'
import moment from 'moment'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hres96uLabels
    }
  },
  index () {
    let mockRows = []
    const mockTotal = 100
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        id: i,
        codempid: faker.lorem.word(),
        desc_codempid: faker.name.findName(),
        dtereq: moment().format('DD/MM/YYYY'),
        numseq: faker.random.number(),
        dtechq: moment().format('DD/MM/YYYY'),
        shfreqo: faker.lorem.word(),
        shfreqn: faker.lorem.word(),
        desc_codidchq: faker.name.findName(),
        reason: faker.lorem.words(),
        status: faker.lorem.words(),
        desc_codappr: faker.name.findName(),
        dteappr: moment().format('DD/MM/YYYY'),
        remark: faker.lorem.words(),
        desc_codempap: faker.name.findName()
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detail () {
    let mockTab1 = {
      codempid: faker.lorem.word(),
      desc_codempid: faker.name.findName(),
      dtereq: moment().format('DD/MM/YYYY'),
      dtechq: moment().format('DD/MM/YYYY'),
      codidchq: faker.lorem.word(),
      desc_codidchq: faker.name.findName(),
      codchgsh: faker.lorem.word(),
      desc_codchgsh: faker.lorem.word(),
      reason: faker.lorem.words(),
      codempid2: faker.lorem.word(),
      desc_codempid2: faker.name.findName(),
      shfreqo: faker.lorem.word(),
      desc_shfreqo: moment().format('HH:mm') + ' - ' + moment().format('HH:mm'),
      shfreqn: faker.lorem.word(),
      desc_shfreqn: moment().format('HH:mm') + ' - ' + moment().format('HH:mm'),
      codidchq2: faker.lorem.word(),
      desc_codidchq2: faker.name.findName(),
      shfreqo2: faker.lorem.word(),
      desc_shfreqo2: moment().format('HH:mm') + ' - ' + moment().format('HH:mm'),
      shfreqn2: faker.lorem.word(),
      desc_shfreqn2: moment().format('HH:mm') + ' - ' + moment().format('HH:mm')
    }

    return {
      tab1: mockTab1
    }
  },
  sendApprove () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hres96u/mocker.js